// extracted by mini-css-extract-plugin
var _1 = "NewsboardPostProfileHeaderFooter-moduleNewsboardPostProfileHeaderFooter__b5c_J";
export { _1 as "NewsboardPostProfileHeaderFooter" }
